const SCHEDULER_FLAG_KEY = "scheduler";
const SCHEDULE_ACTION_FLAG_KEY = "schedule_action";

export function isSchedulerLdEnabled(flags: Record<string, unknown> | undefined): boolean {
  if (!flags || typeof flags !== "object") {
    return false;
  }
  return flags[SCHEDULER_FLAG_KEY] === true;
}

export function isScheduleActionLdEnabled(flags: Record<string, unknown> | undefined): boolean {
  if (!flags || typeof flags !== "object") {
    return false;
  }
  return flags[SCHEDULE_ACTION_FLAG_KEY] === true;
}
